import { withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'

import { SentryErrorPage } from '@/pages/error/SentryErrorPage'
import { RegionPromotionPage } from '@/pages/promotions/RegionPromotionPage'

export const Route = createFileRoute('/promotions/$initiativeId/$regionId/')({
  component: withErrorBoundary(RegionPromotionPage, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
})
